import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2.01L2 22l4-4h16V2zm-4 12l-4-3.2V14H6V6h8v3.2L18 6v8z"
}), 'VoiceChatSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VoiceChatSharp.js
// module id = 7148
// module chunks = 2